import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbDialogService, NbToastrService } from '@nebular/theme';
import { SharedService } from '../../services/shared.service';
import { getTotalCreditCount, User } from 'src/app/models/users.model';
import { IPlan } from 'src/app/models/plan.model';
import { CardDetailsComponent } from '../card-details/card-details.component';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { mapCodeToCountryCurrencyCode, mapCodeToCountryCurrencySymbol } from 'src/app/models/country-code-mapper';
import { IPriceInfo } from '../../../models/price-info.model';
import { IPaddlePassthrough } from 'src/app/models/paddle-passthrough';

@Component({
  selector: 'app-add-credits',
  templateUrl: './add-credits.component.html',
  styleUrls: ['./add-credits.component.scss'],
})
export class AddCreditsComponent implements OnInit {
  user: User;
  loading = false;
  plans: Observable<IPlan[]>;

  get totalCreditCount() {
    if (!this.user) {
      return null;
    }
    return getTotalCreditCount(this.user);
  }

  constructor(
    private afs: AngularFirestore,
    private ss: SharedService,
    protected dialog: NbDialogService,
    protected toastr: NbToastrService,
    protected dialogRef: NbDialogRef<AddCreditsComponent>,
  ) {}

  async ngOnInit() {
    this.plans = this.afs.collection<IPlan>(`plans`, (ref) => ref.orderBy('credits', 'asc')).valueChanges();
    this.user = await this.ss.getUser();
  }

  buyClicked(plan: IPlan) {
    this.dialogRef.close();

    const passthrough: IPaddlePassthrough = {
      userUid: this.user.uid,
    };

    window.Paddle.Checkout.open({
      product: +plan.paddleProductId,
      email: this.user.email,
      allowQuantity: false,
      passthrough: JSON.stringify(passthrough),
    });
  }

  getPriceInfo(plan: IPlan): IPriceInfo {
    const usersCurrencyCode = mapCodeToCountryCurrencyCode(this.user.countryCode);
    const usersCurrencySymbol = mapCodeToCountryCurrencySymbol(this.user.countryCode);
    const price = plan.prices?.[usersCurrencyCode] ?? plan.prices.usd;

    return { price: price, currencyCode: usersCurrencyCode, currencySymbol: usersCurrencySymbol };
  }

  cancelClicked() {
    this.dialogRef.close();
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
